<template>
  <section class="partners-section" id="partners">
    <v-container class="partners-container animate-block">
      <!-- Section Header -->
      <div class="section-header">
        <p class="section-title">{{ $t('partners.title') }}</p>
      </div>

      <!-- Partners Grid -->
      <v-row no-gutters class="partners-grid">
        <v-col
          v-for="(partner, index) in partners"
          :key="index"
          cols="6"
          md="3"
          class="grid-cell"
        >
          <div class="partner-card">
            <div class="logo-place">
              <img
                v-if="partner.logo"
                :src="partner.logo"
                :alt="partner.name"
                class="logo-image"
              />
              <span v-else class="logo-placeholder">{{ partner.shortName }}</span>
            </div>
            <p class="partner-name">{{ partner.name }}</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { animateOnScroll } from '@/mixins/animateOnScroll'

export default {
  name: 'PartnersSection',
  mixins: [animateOnScroll],
  data() {
    return {
      partners: [
        {
          name: 'TRANSELIT S.A.',
          shortName: 'TRANSELIT',
          logo: require('@/assets/images/6.PartnersSection/1.webp')
        },
        {
          name: 'GRAWE CARAT ASIGURARI S.A.',
          shortName: 'GRAWE',
          logo: require('@/assets/images/6.PartnersSection/2.webp')
        },
        {
          name: 'MOLDCARGO S.A.',
          shortName: 'MOLDCARGO',
          logo: require('@/assets/images/6.PartnersSection/3.webp')
        }
      ]
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400&display=swap');

.partners-section {
  scroll-margin-top: 126px;
  background-color: #ededed;
  display: flex;
  justify-content: center;
  padding: 80px 0 60px;
}

.partners-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
}

/* Header */
.section-header {
  max-width: 511px;
}

.section-title {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 32px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 41.6px;
  color: rgb(46, 46, 46);
  margin: 0;
}

/* Grid */
.partners-grid {
  width: 100%;
  gap: 10px;
}

.grid-cell {
  padding: 0 !important;
  max-width: calc(25% - 7.5px);
  flex-basis: calc(25% - 7.5px);
}

/* Partner Card */
.partner-card {
  background-color: #dedede;
  border-radius: 4px;
  height: 198px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 15px;
  overflow: hidden;
  transition: background-color 0.2s ease;
}

.partner-card:hover {
  background-color: #e8e8e8;
}

/* Logo area */
.logo-place {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-image {
  display: block;
  max-width: 100%;
  max-height: 78px;
  object-fit: contain;
}

.logo-placeholder {
  font-family: "JetBrains Mono", monospace;
  font-size: 12px;
  font-weight: 400;
  color: rgb(103, 103, 103);
  text-transform: uppercase;
  letter-spacing: -0.04em;
  text-align: center;
}

/* Partner name */
.partner-name {
  font-family: "JetBrains Mono", monospace;
  font-size: 8px;
  font-weight: 400;
  letter-spacing: -0.04em;
  color: rgb(103, 103, 103);
  text-transform: uppercase;
  margin: 0;
  margin-top: auto;
  padding-bottom: 6px;
  align-self: flex-start;
  padding-left: 2px;
}

/* Responsive */
@media (max-width: 960px) {
  .partners-section {
    padding: 60px 0;
  }

  .grid-cell {
    max-width: calc(50% - 5px);
    flex-basis: calc(50% - 5px);
  }

  .section-header {
    width: 100%;
  }

  .section-title {
    font-size: 26px;
    line-height: 34px;
  }
}

@media (max-width: 600px) {
  .partners-section {
    padding: 40px 0;
  }

  .section-title {
    font-size: 22px;
    line-height: 30px;
  }
}
</style>
